import AnnotationsBaseHandler from 'webapp/d-chart/annotations/base';

export default class AnnotationsHeatmapHandler extends AnnotationsBaseHandler {
	// annotatablePointsIds: string[] - point ids are timestamp strings

	protected getLabelPointForAnnotatablePoint(
		annotatablePointId: string,
	): { x: number; y: number } | null {
		if (!annotatablePointId) {
			return null;
		}

		const m = this.renderer.dChart.sizeModifier,
			seriesPoints = this.hChart.series[0]?.points || [],
			seriesPoint = seriesPoints.find((p) => p.category === annotatablePointId);

		if (!seriesPoint) {
			return null;
		}

		// the heatmap cell (Highcharts types shapeArgs as any SVG attributes)
		const shapeArgs = seriesPoint.shapeArgs as
			{ x: number; y: number; width: number; height: number } | undefined;

		if (!shapeArgs) {
			return null;
		}

		const posX = shapeArgs.x + m,
			posY = shapeArgs.y + shapeArgs.height - 0.3 * m;

		// returning exact pixels according to shapeArgs - to position annotation label in left bottom corner.
		return {
			x: posX,
			y: posY,
		};
	}
}
